import { LitElement } from 'lit-element';

export class CustomLitElement extends LitElement {
  // To be discussed
  // constructor() {
  //   super();
  //
  //   const styles = document.createElement('style');
  //
  //   styles.innerHTML = `@import url('https://fonts.googleapis.com/css2?family=Karla&family=Roboto&display=swap');`;
  //   document.head.appendChild(styles);
  // }
}
